import { HistoryDto, HistoryDtoHistoryType, PatientBasicsDto } from '../../api/generated/model';
import { HistoryFilter } from '../../state/historySearchAtoms.ts';

export function getHistoryFilterName(historyFilter: HistoryFilter) {
  switch (historyFilter) {
    case HistoryFilter.ALL:
      return 'Alle Anzeigen';
    case HistoryFilter.JOURNAL:
      return 'Nur Notizen';
    case HistoryFilter.UPDATES:
      return 'Nur Updates';
  }
}
export function filterHistory(
  history: HistoryDto[],
  historyFilter: HistoryFilter,
  selectedPatient: PatientBasicsDto | null,
) {
  const historyForPatient = selectedPatient
    ? history.filter((history) => history.patientId === selectedPatient.id)
    : history;

  switch (historyFilter) {
    case HistoryFilter.ALL:
      return historyForPatient;
    case HistoryFilter.JOURNAL:
      return historyForPatient.filter((history) => history.historyType === HistoryDtoHistoryType.JOURNAL_ENTRY);
    case HistoryFilter.UPDATES:
      return historyForPatient.filter((history) => history.historyType !== HistoryDtoHistoryType.JOURNAL_ENTRY);
  }
}
